import { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getAllEmpresas } from "component/api";
import { MenuProps } from "component/utilies/utilies";

import "./MultipleSelect.css";

function MultipleSelect(props) {
  const [options, setOptions] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  let empresasMultipleSelect = [];

  async function getAllEmpresasFunc() {
    const res = await getAllEmpresas();
    setEmpresas(res.data);

    for (let i = 0; i < res.data.length; i++) {
      let string = res.data[i].razonSocial;

      empresasMultipleSelect.push(string);

      setOptions(empresasMultipleSelect);
    }
  }

  let empresasId = [];

  function addEmpresasId() {
    for (let i = 0; i < selected.length; i++) {
      for (let j = 0; j < empresas.length; j++) {
        if (selected[i] === empresas[j].razonSocial) {
          empresasId.push(empresas[j].id);
        }
      }
    }

    localStorage.setItem("empresasId", empresasId);
  }

  useEffect(() => {
    try {
      getAllEmpresasFunc();

      addEmpresasId();
    } catch (err) {
      console.log(err);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      addEmpresasId();
    } catch (err) {
      console.log(err);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresasId]);

  const [selected, setSelected] = useState([]);
  const isAllSelected =
    options.length > 0 && selected.length === options.length;

  const handleChange = (event) => {
    const value = event.target.value;

    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options.length ? [] : options);
      return;
    }
    setSelected(value);
    addEmpresasId();
  };

  return (
    <FormControl variant="standard">
      <InputLabel id="mutiple-select-label" style={{ fontSize: "20px" }}>
        {props.title}
      </InputLabel>
      <Select
        labelId="mutiple-select-label"
        multiple
        value={selected}
        onChange={handleChange}
        renderValue={(selected) => selected.join(", ")}
        MenuProps={MenuProps}
        style={{ height: "55px" }}
        error={!!props.error}
      >
        <MenuItem
          value="all"
          classes={{
            root: isAllSelected ? "selected-all__multiple-select " : "",
          }}
        >
          <ListItemIcon>
            <Checkbox
              style={{ color: "blue" }}
              classes={{
                indeterminate: "indeterminate-color__multiple-select",
              }}
              checked={isAllSelected}
              indeterminate={
                selected.length > 0 && selected.length < options.length
              }
            />
          </ListItemIcon>

          <ListItemText
            classes={{ primary: "select-all-text__multiple-select" }}
            primary="Todas las Empresas"
          />
        </MenuItem>

        {options.map((option, index) => (
          <MenuItem key={`${option}-${index}`} value={option}>
            <ListItemIcon>
              <Checkbox
                style={{ color: "blue" }}
                checked={selected.indexOf(option) > -1}
              />
            </ListItemIcon>

            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultipleSelect;
